class ApiUser {
    constructor(Restangular, ApiBaseResponseService) {
        return {

            /**
             * Sign up user
             */
            signUpUser(user) {
                return Restangular
                    .all('users')
                    .all('register')
                    .post(user)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            /**
             * Edit of current user
             * @param  {Object} user
             * @return {void}
             */
            changeUser(user, isPurchase) {
                return Restangular
                    .one('users', user.userId)
                    .customPUT(user, '', {'purchase' : isPurchase})
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);

            },

            getUser() {
                return Restangular
                    .all('users')
                    .customGET('getUserData')
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getTaxRate(){
                return Restangular
                    .one('users/taxRate')
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            toggleFreezeUser(id) {
              return Restangular
                  .all('users')
                  .all('freeze')
                  .post(null, { userId: id })
                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            deactivateStartupWizard() {
              return Restangular
                  .all('users')
                  .all('deactivateStartupWizard')
                  .post()
                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            }
        };
    }
}

ApiUser.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiUser;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiUser.js
 **/